var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactoryAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H15V19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19V22H4C2.89543 22 2 21.1046 2 20V13.4009C2 12.5598 2.52613 11.8087 3.31651 11.5213L4.25 11.1818V7C4.25 6.58579 4.58579 6.25 5 6.25C5.41421 6.25 5.75 6.58579 5.75 7V10.6364L8.25 9.72727V5C8.25 4.58579 8.58579 4.25 9 4.25C9.41421 4.25 9.75 4.58579 9.75 5V9.18182L12.3417 8.23937C12.7369 8.09566 13 7.72008 13 7.29957V4C13 2.89543 13.8954 2 15 2H20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryAlt3);
export default __webpack_public_path__ + "static/media/factory-alt-3.eb70840378da6b2a4494288aeaf83cab.svg";
export { ForwardRef as ReactComponent };